const localization = {
  rial: 'ریال',
  toman: ' تومان ',
  refuse: 'انصراف',
  tryAgain: 'تلاش مجدد',
  remainPrice: 'باقیمانده فاکتور',
  cancelPayment: 'لغو پرداخت',
  cancelPaymentAndExit: 'لغو پرداخت و خروج',
  continuePayment: 'ادامه فرآیند پرداخت',
  doYouWantCancelPayment: 'میخواهید پرداخت را لغو کنید؟',
  confirmAnContinue: 'تایید و ادامه',
  pleaseInsertNumber: 'لطفا عدد وارد کنید.',
  invalidPhoneNumber: 'شماره تلفن نامعتبر',
  maxNumberCountExceeded: 'تعداد اعداد بیش از مقدار مجاز است',
  pleaseWaitAMoment: 'لطفا چند لحظه منتظر بمانید',
  enterVerificationCode: 'ورود کد تایید',
  enterTheVerificationCode: 'کد تایید را واردکنید',
  verificationCodeText1: 'ما یک رمز یکبار مصرف به شماره موبایل',
  verificationCodeText2: ' ارسال کرده ایم، لطفا برای ادامه رمز را وارد نمایید.',
  enter: 'ورود',
  onTimePass: 'رمز یکبار مصرف را وارد کنید.',
  exit: 'خروج',
  goBack: 'بازگشت',
  paymentIsExpired: 'پرداخت منقضی شد',
  paymentIsExpiredCaption:
    'زمان پرداخت شما به پایان رسیده است. برای پرداخت سفارش، مجددا به سایت فروشنده بازگردید.',
  requestOTPAgain: 'ارسال مجدد رمز یکبار مصرف',
  selectAccountInfo: 'برای پرداخت، لطفا کیف‌پول و کوپن‌های مورد نظر خود را انتخاب کنید.',
  selectYourAccountsForBuy: 'حساب های مورد نظر را جهت استفاده برای خرید انتخاب کنید.',
  selectYourCouponsForBuy: 'کوپن های مورد نظر را جهت استفاده برای خرید انتخاب کنید.',
  ozoneGateWay: 'درگاه پرداخت اوزون',
  yourPaymentTimeIsEnded: 'زمان پرداخت شما به پایان رسید',
  chooseAccount: 'انتخاب حساب',
  chooseGiftCard: 'انتخاب کارت هدیه',
  chooseCoupon: 'انتخاب کوپن',
  thereIsNoCoupon: 'کوپن موجود نیست',
  zeroAmount: 'مبلغ صفر',
  biggerAmount: 'مبلغ بیشتر از فاکتور',
  zeroAmountCaption:
    'مبلغ قابل پرداخت شما صفر شده است و نیاز به انتخاب کیف پول دیگری نیست. در صورت نیاز به استفاده از این کیف پول، انتخاب‌های قبلی خود را تغییر دهید.',
  zeroVoucherAmountCaption:
    'مبلغ قابل پرداخت شما صفر شده است و نیاز به انتخاب کوپن دیگری نیست. در صورت نیاز به استفاده از این کوپن، انتخاب‌های قبلی خود را تغییر دهید.',
  biggerVoucherAmountCaption:
    'مبلغ پرداخت شما بیشتر از مقدار فاکتور شده است و امکان انتخاب این کوپن نیست. در صورت نیاز به استفاده از این کوپن، انتخاب‌های قبلی خود را تغییر دهید.',
  confirm: 'تایید',
  totalInvoiceAmount: 'مبلغ کل فاکتور',
  theAmountPayable: 'مبلغ قابل پرداخت',
  useCoupon: 'استفاده از کوپن',
  withdrawFromAccount: 'برداشت از حساب',
  withdrawFromAccountRial: 'برداشت از حساب (ریال)',
  invoice: 'پیش فاکتور',
  payAt: 'خرید از',
  totalAccountDiscount: 'جمع تخفیف حساب',
  amountDeductedInvoice: 'مبلغ کسر از فاکتور',
  payment: 'تایید و پرداخت',
  remainPayment: 'پرداخت باقیمانده',
  yourLostYourConnection: 'عدم اتصال به اینترنت',
  yourLostYourConnectionCaption:
    'اتصال شما به اینترنت برقرار نیست. لطفاً از وضعیت شبکه خود اطمینان حاصل کرده و دوباره امتحان کنید.',
  pageNotFound: 'صفحه یافت نشد',
  thePageIsNotAccessible:
    'متاسفانه صفحه مورد نظر شما در دسترس نیست یا ممکن است حذف شده باشد. لطفاً آدرس را بررسی کرده یا به صفحه اصلی بازگردید.',
  goToPreviousPagePlease: 'متاسفانه صفحه‌ای که دنبال آن بودید پیدا نشد.',
  selectAccount: 'انتخاب حساب',
  selectedCoupon: 'کوپن انتخاب شده',
  selectCoupon: 'انتخاب کوپن',
  record: 'ثبت',
  chooseAccountAndCoupon: 'کوپن و حساب انتخاب کنید',
  haveGiftCard: 'کارت هدیه دارم',
  addGiftCard: 'افزودن کارت هدیه',
  enterYourGiftCardData: 'اطلاعات کارت هدیه خود را وارد کنید.',
  add: 'افزودن',
  cardRecord: 'ثبت کارت',
  merchant: 'پذیرنده',
  invoiceTotalAmount: 'مبلغ کل فاکتور',
  wallets: 'کیف ‌پول‌ها',
  otherWallets: 'سایر کیف‌ پول‌ها',
  youHaveNoWallet: 'کیف‌پول قابل خرج در این خرید ندارید.',
  vouchers: 'کوپن‌ها',
  discounts: 'تخفیف‌ها',
  youHaveNoVouchers: 'کوپن قابل خرج در این خرید ندارید.',
  walletPayableAmount: (amount: string) => `موجودی: ${amount} ریال`,
  payableAmount: 'مبلغ قابل برداشت',
  walletInvoicePayableAmount: (amount: string) => `سقف برداشت: ${amount} ریال`,
  clickForAmount: 'برای دریافت موجودی کلیک کنید.',
  seeMore: 'مشاهده بیشتر',
  remainExpiration: (remainDays: number) => `انقضا: ${remainDays} روز دیگر`,
  confirmAmount: 'تایید مبلغ',
  inputWithdrawAmount: 'سقف مبلغ برداشت از کیف پول را وارد کنید',
  unUsableWallets: 'کیف‌پول‌های غیرفعال در این خرید',
  unUsableWalletsInStore: 'دارایی‌های زیر در این خرید قابل استفاده نیستند.',
  walletsWithoutAmount: 'کیف‌پول‌های بدون موجودی',
  unUsableWithoutAmount:
    'کیف‌پول‌های زیر به دلیل عدم موجودی، در این خرید قابل استفاده نیستند.',
  unUsableVouchers: 'کوپن‌های غیرفعال در این خرید',
  unUsableVouchersInStore: 'کوپن‌های زیر در این خرید قابل استفاده نیستند.',
  confirmSelection: 'تایید انتخاب',
  cancelConfirm: 'عدم تایید',
  andOtherWallets: (wallet: string) => `${wallet} و باقی موارد انتخابی،`,
  cantTogether: (selectedWallet: string, otherWallets: string) =>
    ` به صورت همزمان قابل خرج نیستند. در صورت انتخاب ${selectedWallet}، ${otherWallets} شما از حالت انتخاب خارج خواهد شد.`,
  otherWalletsAmountSum: 'مجموع تخفیف سایر انتخاب‌ها',
  discountWith: (wallet: string) => `تخفیف با ${wallet}`,
  finalPreInvoice: 'پیش فاکتور نهایی',
  acceptAndPay: 'تایید نهایی و پرداخت',
  biometricPaymentFailed: 'تایید بایومتریک انجام نشد',
  biometricRequiredHint: 'پرداخت شما فقط با تایید بایومتریک انجام می‌شود',
  verifyWithBiometric: 'تایید با بایومتریک',
  deviceCheckTitle: 'تایید بایومتریک لازم است',
  deviceCheckBody: 'شما پرداخت را فقط برای دستگاهی فعال کرده‌اید که بایومتریک آن در اپ اوزون ثبت شده است. لطفاً با همان دستگاه پرداخت کنید یا بایومتریک این دستگاه را از اپ اوزون ثبت کنید.',
  deviceCheckUnsupported: 'این دستگاه یا مرورگر از تایید بایومتریک پشتیبانی نمی‌کند. لطفاً با دستگاه ثبت‌شده خود پرداخت کنید.',
  graterThanPayableAmount: 'مبلغ وارد شده، بیش از مبلغ قابل پرداخت است.',
  graterThanWalletAmount: 'مبلغ برداشت، بیشتر از موجودی کیف پول است.',
  voucherForSpecificItems: 'کوپن‌های مربوط به کالای خاص',
  voucherForSpecificItemsCaption:
    'کوپن‌های زیر مربوط به کالاهای خاص است. برای مشاهده کالاها، به اپلیکیشن اوزون مراجعه کنید.',
  vouchersWithMinimumInvoice: 'کوپن‌های با حداقل مبلغ صورتحساب',
  vouchersWithMinimumInvoiceCaption:
    'مبلغ صورتحساب شما به حداقل مورد نیاز برای استفاده از کوپن‌های زیر نرسیده است. برای مشاهده حداقل مبلغ صورتحساب مورد نیاز، به اپلیکیشن اوزون مراجعه کنید.',
  maximumVoucherInvoice: (v: number) => ` حداکثر ${v} کوپن در این خرید قابل انتخاب است.`,
  //
  wrongPgc: 'پرداخت نامعتبر',
  sorryWrongPgc:
    'متاسفانه شناسه پرداخت وارد شده معتبر نیست. لطفاً اطلاعات پرداخت را بررسی کرده و مجدداً تلاش کنید.',
  developmentNote:
    'این محیط آزمایشی است، از انجام تراکنش در این صفحه خودداری کنید و با پشتیبانی سایت تماس بگیرید.',
  goToOzoneGateway: 'درگاه پرداخت اوزون',
  ozoneGateway: 'درگاه پرداخت ترکیبی اوزون کارت',
  policy: 'تمامی حقوق این درگاه متعلق به اوزون کارت می باشد.',
  invoiceDeductionDetail: 'جزئیات کسر از فاکتور',
  useGiftCard: 'استفاده از کارت هدیه',
  useGift: 'استفاده از هدیه',
  totalDeductionFromTheInvoice: 'جمع کسر از فاکتور',
  invoiceBalance: 'مبلغ فاکتور',
  orderSummery: 'خلاصه سفارش',
  coupon: 'کوپن',
  coupons: 'کوپن ها',
  discountWithCoupon: 'تخفیف کوپن',
  account: 'حساب',
  selected: 'انتخاب شده',
  disposable: 'یکبار مصرف',
  canNotUseCoupon: 'این کوپن قابل خرج در این فروشگاه نیست.',
  canNotUseAccount: 'این حساب قابل خرج با بعضی حساب ها نیست ',
  close: 'بستن',
  noCoupon: 'کوپن ندارید',
  noWallet: 'حسابی ندارید',
  discount: 'تخفیف',
  editAmount: 'ویرایش مبلغ',
  ozoneCapsule: 'مبلغ قابل برداشت از کپسول اوزون',
  giftCardBalance: 'موجودی کارت هدیه',
  withdrawFromGiftCard: 'برداشت از کارت هدیه',
  expire: 'انقضا',
  gift: 'هدیه',
  returnToReceivingSite: (time?: string | number) =>
    time ? `بازگشت به سایت پذیرنده (${time})` : 'بازگشت به سایت پذیرنده ',
  moreInfo: (time?: string | number) => `آشنایی بیشتر(${time})`,
  returnToMerchant: 'بازگشت به سایت پذیرنده',
  successfulTransaction: 'تراکنش موفق',
  transactionFailed: 'تراکنش ناموفق',
  refuseFromPayment: 'انصراف از پرداخت',
  askForQRcode: 'در صورت نیاز به تکمیل خرید، QR-Code جدید را از صندوقدار بخواهید.',
  dataAndTime: 'تاریخ و ساعت',
  acceptor: 'پذیرنده',
  issueTracking: 'شماره پیگیری',
  totalAmountPaid: ' کل مبلغ پرداخت شده',
  select: 'انتخاب',
  iGetIt: 'متوجه شدم',
  minimumBankReq:
    'حداقل مبلغ قابل پرداخت درگاه‌های بانکی ۵,۰۰۰ تومان است؛ به همین منظور مبالغ برداشت از حساب به روز رسانی شد',
  accountWithdrawDetails: 'جزئیات برداشت از حساب ها',
  selectGiftCard: 'انتخاب هدیه',
  canNotUseCouponWhite: 'امکان استفاده از این کوپن با کوپن‌های زیر وجود ندارد:',
  canNotUseAccountWith: 'امکان خرج این حساب با حساب‌های زیر وجود ندارد:',
  invalidWithdrawAmount: 'مبلغ وارد شده بیشتر از موجودی حساب شما است.',
  invalidGiftCardWithdrawAmount: 'مبلغ وارد شده بیشتر از موجودی کارت هدیه شما است.',
  minimumWithdrawAmount: 'حداقل مبلغ برداشت  ۱,۰۰۰ تومان است.',
  giftCard: 'کارت هدیه',
  invoiceBalanceIsZero: 'باقی مانده فاکتور صفر شد',
  canNotAddWallet: 'امکان افزودن حساب نیست؛ مبلغ قابل پرداخت شما صفر شده است',
  canNotAddCoupon: 'امکان افزودن کوپن نیست؛ مبلغ قابل پرداخت شما صفر شده است',
  amountGraterThanRemainInvoice: 'مبلغ وارد شده بیشتر از باقی مانده فاکتور است.',
  amountGraterThanInvoice: 'مبلغ وارد شده بیشتر از مبلغ فاکتور است.',
  walletBalanceIsZero: 'موجودی حساب صفر ریال است.',
  tokenIsExpire: 'توکن منقضی شده است',
  timeWithMinute: (m: number, s: number) => `${m} دقیقه و ${s} ثانیه تا ارسال دوباره`,
  timeWithSecond: (s: number) => ` ${s} ثانیه تا ارسال دوباره`,
  toReceiveOtp: 'دریافت مجدد رمز یکبار مصرف:  ',
  scoreVoucher: 'کوپن امتیازی',
  paymentIsNotComplete: 'پرداخت تکمیل نشد!',
  paymentIsNotCompleteInIPG: 'پرداخت شما در درگاه بانکی تکمیل نشد.',
  youForgotten: 'یادت رفت!',
  forgottenText:
    'یادت رفت موجودی یا تخفیف‌هات رو انتخاب کنی! اگه دوست داری برگرد یه نگاهی بهشون بنداز.',
  comeBackToChoose: 'بازگشت برای انتخاب',
  importantDescription: ' توضیح مهم درباره مبلغ «هزینه سرویس درگاه»',
  paymentServiceTxt:
    'اوزون هیچ هزینه‌ای با عنوان «سرویس درگاه» از کاربران دریافت نمی‌کند. این مبلغ از سوی تپسی‌شاپ دریافت شده است و هیچ ارتباطی با اوزون ندارد. در صورت نیاز برای اطلاعات بیشتر با پشتیبانی تپسی‌شاپ تماس بگیرید. ',
  changeAmount: 'تغییر مبلغ برداشت',
  activationChangeAmountHint:
    'با فعالسازی این ویژگی، شما می‌توانید مبلغ برداشت از هر کیف پول را مشخص کنید.',
  canChangeAmount: 'امکان تغییر مبلغ برداشت',
  customGateway: (txt: string) => `درگاه پرداخت ${txt}`,
  balance: 'موجودی',
  howToPurchase: 'نحوه برداشت از کیف پول',
  default: 'پیشفرض',
  defaultAmount: 'برداشت مبلغ به صورت پیشفرض',
  userWantedAmount: 'مبلغ دلخواه',
  userEnteredAmount: 'برداشت مبلغ دلخواه',
  paymentDetail: 'جزئیات پرداخت',
  deActiveInThisStore: 'غیرفعال در این فروشگاه',
  zeroBalance: 'موجودی صفر',
  voucherPermissionItem: 'مربوط به کالای خاص',
  voucherMinimumInvoiceAmount: 'با حداقل مبلغ صورتحساب',
  notUseAbleInThisStore: 'غیر قابل استفاده در این فروشگاه',
  assetCantSpendable: (asset: string) =>
    `${asset}، امکان استفاده همزمان با دارایی‌های زیر را ندارد. برای استفاده، ابتدا دارایی‌های زیر را از حالت انتخاب خارج کنید.`,
  InvoiceVoucherLimitationMaximumConcurrentUseCount:
    'شما حداکثر تعداد کوپن قابل استفاده به صورت همزمان را انتخاب کرده‌اید.', // code:20
  voucherRuleTypeMaximumConcurrentUseCount:
    'تعداد استفاده همزمان از یک نوع کد تخفیف از حد مجاز بیشتر شده است.', // code:15
  SumSegmentAmountBiggerThanInvoiceAmount:
    'شما حداکثر تعداد کوپن قابل استفاده به صورت همزمان را انتخاب کرده‌اید.', // code:5
  CombinationError: 'خطا در ترکیب / ناسازگاری ترکیب قوانین یا آیتم‌ها.',
  PayWithId: 'پرداخت با شناسه کیپا',
  EnterPaymentId: 'شناسه پرداخت کیپا دارید؟ وارد کنید...',
  paymentWithIPG: 'پرداخت با درگاه اینترنتی',
  userPaymentHint: 'شما در اوزون کیف‌پول یا کوپن برای پرداخت این فاکتور ندارید. برای پرداخت فاکتور می‌توانید از یکی از روش‌های زیر استفاده کنید.',
  ifYouHavePaymentId: 'در صورتی که شناسه پرداخت کیپا دارید، وارد کنید.',
  enterPaymentIdPlaceholder: 'شناسه پرداخت کیپا دارید؟ وارد کنید...',
  confirmTheId: 'تایید شناسه',
  acceptPaymentWithId: (provider: string) => `تایید پرداخت با ${provider}`,
  acceptPaymentWithIdHint: (provider: string) => `برای ادامه پرداخت، رمز پرداخت ${provider} را وارد کنید. این رمز ممکن است رمز ثابت شما باشد یا رمز پویایی که از اپلیکیشن یا پیامک ${provider} دریافت می‌کنید.`,
  paymentIdOtpPlaceholder: 'رمز پرداخت را وارد کنید.',
  addTheWallet: 'افزودن کیف‌پول',
  walletProviderAmount: (amount?:string) => `موجودی قابل خرج: ${amount} ریال`,
  discountWithOzone: 'با انتخاب کارت اوزون، در همین خرید ۵٪ تخفیف بیشتر بگیر.',
  bankCard: 'کارت بانکی',
  inTransferringToUpg: 'در حال انتقال به درگاه پرداخت'
};
export default localization;
